import React, { useCallback } from "react";
import { chunk, sortBy } from "lodash";

import { useTalon } from "../../../hooks/useTalon";
import { useDeclarer } from "../../../hooks/useDeclarer";

import { Card } from "../shared/Card";

import { Card as CardType } from "../../../types/types";
import {
  selectIAmDeclarer,
  selectCurrentGameTalon,
} from "../../../store/selectors";
import { useSelector } from "react-redux";

export const TalonPicker: React.FC = () => {
  const { takeFromTalon, talonCount } = useTalon();
  const { name: declarerName } = useDeclarer();
  const iAmDeclarer = useSelector(selectIAmDeclarer);
  const talon = useSelector(selectCurrentGameTalon);
  const onClickCardGroup = useCallback(
    async (cards: CardType[]) => {
      if (iAmDeclarer) {
        await takeFromTalon(cards);
      }
    },
    [takeFromTalon, iAmDeclarer]
  );

  if (talon === undefined) {
    return <div className="text-emerald-200">Loading...</div>;
  }

  if (!iAmDeclarer) {
    return (
      <div className="text-emerald-100 text-lg font-medium animate-pulse">
        Waiting for {declarerName} to pick Talon...
      </div>
    );
  }

  switch (talonCount) {
    case undefined:
      return <div className="text-red-300">Something went wrong: talon count not found</div>;
    case 3:
      return (
        <div className="text-center">
          <h2 className="text-2xl font-bold mb-6 text-white">Pick Your Talon Cards</h2>
          <div className="flex space-x-6 items-center justify-center">
            {chunk(
              sortBy(talon, (c) => c.index),
              3
            ).map((cards) => (
              <div
                key={cards.map((c) => c.slug).join(",")}
                className="flex space-x-2 bg-white/10 rounded-xl p-4 border-2 border-transparent cursor-pointer transition-all hover:border-emerald-400 hover:bg-white/20 hover:scale-105"
                onClick={() => onClickCardGroup(cards)}
              >
                {cards.map((c) => (
                  <Card key={c.slug} slug={c.slug} />
                ))}
              </div>
            ))}
          </div>
        </div>
      );
    case 6:
      return (
        <div className="text-center">
          <h2 className="text-2xl font-bold mb-6 text-white">Take the Talon</h2>
          <div
            className="flex space-x-2 bg-white/10 rounded-xl p-4 border-2 border-transparent cursor-pointer transition-all hover:border-emerald-400 hover:bg-white/20 hover:scale-105 inline-flex"
            onClick={() => onClickCardGroup(talon)}
          >
            {sortBy(talon, (c) => c.index).map((c) => (
              <Card key={c.slug} slug={c.slug} />
            ))}
          </div>
        </div>
      );
  }
};
